import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useHiringApi, errMsg } from '../../components/admin/hiring/useHiringApi';
import ApplicantHeader from '../../components/admin/hiring/ApplicantHeader';
import ApplicantAnswers from '../../components/admin/hiring/ApplicantAnswers';
import ApplicantInterviews from '../../components/admin/hiring/ApplicantInterviews';
import ApplicantTrialClean from '../../components/admin/hiring/ApplicantTrialClean';
import ApplicantOfferDecision from '../../components/admin/hiring/ApplicantOfferDecision';
import ApplicantMessages from '../../components/admin/hiring/ApplicantMessages';
import ApplicantNotes from '../../components/admin/hiring/ApplicantNotes';
import ConvertToGuruDialog from '../../components/admin/hiring/ConvertToGuruDialog';

export default function AdminApplicantPage() {
  const { id } = useParams();
  const api = useHiringApi();
  const [a, setA] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [error, setError] = useState('');
  const [convertOpen, setConvertOpen] = useState(false);

  const load = useCallback(async () => {
    try { setA(await api.get(id)); } catch (e) { setError(errMsg(e, 'Applicant not found')); }
  }, [api, id]);
  useEffect(() => { load(); api.config().then(setCfg).catch(() => {}); }, [load, api]);

  if (error) return <><p className="p-10 text-center text-zinc-500" data-testid="applicant-error">{error}</p></>;
  if (!a) return <><p className="p-10 text-center text-zinc-400">Loading…</p></>;

  const onUpdated = (doc) => setA(doc);
  return (
    <>
      <div className="min-h-screen" data-testid="admin-applicant-page">
        <ApplicantHeader a={a} cfg={cfg} onUpdated={onUpdated} onConvert={() => setConvertOpen(true)} />
        <main className="max-w-[1500px] mx-auto px-4 sm:px-6 lg:px-8 py-6 grid grid-cols-1 xl:grid-cols-5 gap-5">
          <div className="xl:col-span-2"><ApplicantAnswers a={a} /></div>
          <div className="xl:col-span-3 space-y-4">
            <ApplicantInterviews a={a} cfg={cfg} onUpdated={onUpdated} />
            <ApplicantTrialClean a={a} cfg={cfg} onUpdated={onUpdated} />
            <ApplicantOfferDecision a={a} onUpdated={onUpdated} />
            <ApplicantMessages a={a} cfg={cfg} onUpdated={onUpdated} />
            <ApplicantNotes a={a} onUpdated={onUpdated} />
          </div>
        </main>
        <ConvertToGuruDialog key={a.id} a={a} open={convertOpen} onOpenChange={setConvertOpen} onConverted={() => { setConvertOpen(false); load(); toast.success('Recruiting record linked to the new Guru'); }} />
      </div>
    </>
  );
}
